import React, { useState } from 'react';
import { useQuery, gql } from '@apollo/client';
import debounce from 'lodash/debounce';

import Results from './Results';

const SEARCH_PRODUCTS = gql`
  query SearchProducts(
    $searchString: String
    $sorting: Sorting
    $pagination: Pagination
  ) {
    listProducts(
      searchString: $searchString
      sorting: $sorting
      pagination: $pagination
    ) {
      id
      title
      subtitle
      thumbnail
      author
      isbn
    }
  }
`;

const SearchForm = ({ setSelected }) => {
  const debounceSearch = debounce((value) => {
    setSearch(value);
  }, 500);

  const [search, setSearch] = useState('');

  const sorting = {
    orderBy: 'publicationDate',
    order: 'DESC',
  };

  const { data, loading, error } = useQuery(SEARCH_PRODUCTS, {
    variables: {
      searchString: search,
      sorting,
      pagination: {
        offset: 0,
        limit: 20,
      },
    },
    skip: !search,
  });

  return (
    <div className="mt-4">
      <form>
        <div className="mb-3">
          <input
            onChange={(e) => debounceSearch(e.target.value)}
            className="form-control"
            id="newBookSearchInput"
            placeholder="Sök här"
            aria-describedby="newBookSearchHelp"
            style={{
              height: 56,
            }}
          />

          <div id="newBookSearchHelp" className="form-text">
            Sök med titel eller ISBN så hjälper vi dig att fylla på med
            information.
          </div>
        </div>
      </form>

      <Results
        setSelected={setSelected}
        loading={loading}
        error={error}
        products={data?.listProducts}
      />
    </div>
  );
};

export default SearchForm;
